import script from "./signature.vue?vue&type=script&setup=true&name=Signature&lang=js"
export * from "./signature.vue?vue&type=script&setup=true&name=Signature&lang=js"

import "./signature.vue?vue&type=style&index=0&id=4e719de4&scoped=true&lang=css"
import "./signature.vue?vue&type=style&index=1&id=4e719de4&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\虎鲸\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e719de4"]])

export default __exports__